/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BlockEventLabel {
  custom1 = "custom1",
  custom2 = "custom2",
  custom3 = "custom3",
  decisionForChrist = "decisionForChrist",
  gospelPresentationComplete = "gospelPresentationComplete",
  gospelPresentationStart = "gospelPresentationStart",
  inviteFriend = "inviteFriend",
  prayerRequest = "prayerRequest",
  rsvp = "rsvp",
  share = "share",
  specialVideoComplete = "specialVideoComplete",
  specialVideoStart = "specialVideoStart",
}

export enum ButtonAction {
  ChatAction = "ChatAction",
  EmailAction = "EmailAction",
  LinkAction = "LinkAction",
  NavigateToBlockAction = "NavigateToBlockAction",
  PhoneAction = "PhoneAction",
}

export enum ButtonAlignment {
  center = "center",
  justify = "justify",
  left = "left",
  right = "right",
}

export enum ButtonColor {
  error = "error",
  inherit = "inherit",
  primary = "primary",
  secondary = "secondary",
}

export enum ButtonSize {
  large = "large",
  medium = "medium",
  small = "small",
}

export enum ButtonVariant {
  contained = "contained",
  outlined = "outlined",
  text = "text",
}

/**
 * What a machine-translation run writes: `missing` fills only the texts the language has no entry for; `all` also replaces the machine’s earlier translations. A person’s are never replaced.
 */
export enum CampaignAiTranslateMode {
  all = "all",
  missing = "missing",
}

/**
 * What a Campaign Section sits on. Named kinds are theme-slot references; `custom` reads the section backgroundColor; `image` reads the owned cover block.
 */
export enum CampaignBackgroundKind {
  contrast = "contrast",
  custom = "custom",
  image = "image",
  none = "none",
  primary = "primary",
  surface = "surface",
}

/**
 * Overlay strength over an image Section Background: light 0.3, medium 0.55, heavy 0.75. Null means medium.
 */
export enum CampaignBackgroundOverlay {
  heavy = "heavy",
  light = "light",
  medium = "medium",
}

/**
 * Which side of the Section Body an Extra renders on.
 */
export enum CampaignChildPlacement {
  above = "above",
  below = "below",
}

/**
 * The width ratio of the two Column Slots of a Columns section.
 */
export enum CampaignColumnsRatio {
  equal = "equal",
  wideLeft = "wideLeft",
  wideRight = "wideRight",
}

/**
 * How a Featured Media section arranges its text and Media Slot: side by side, or stacked with the media full width under the text.
 */
export enum CampaignFeaturedMediaLayout {
  sideBySide = "sideBySide",
  stacked = "stacked",
}

/**
 * How a Journey List renders its items: a card grid or a list.
 */
export enum CampaignJourneyListDisplay {
  grid = "grid",
  list = "list",
}

/**
 * Which side of a Featured Media section the Media Slot renders on.
 */
export enum CampaignMediaSide {
  left = "left",
  right = "right",
}

/**
 * One of the two pages every Campaign has: the landing page, or the Region Page that every Campaign Region renders.
 */
export enum CampaignPageKind {
  landing = "landing",
  regionTemplate = "regionTemplate",
}

/**
 * Corner radius of the Campaign Theme: square 0, slight 6, rounded 14, veryRounded 24 px.
 */
export enum CampaignRadius {
  rounded = "rounded",
  slight = "slight",
  square = "square",
  veryRounded = "veryRounded",
}

/**
 * The fixed interface phrases every Campaign carries as Campaign Strings.
 */
export enum CampaignStringKey {
  allRegions = "allRegions",
  copied = "copied",
  copy = "copy",
  downloadQr = "downloadQr",
  noJourneys = "noJourneys",
  open = "open",
  openTemplate = "openTemplate",
  seeAllOnWatch = "seeAllOnWatch",
  step1 = "step1",
  step2 = "step2",
  step2help = "step2help",
  step3 = "step3",
  step4 = "step4",
  topCountry = "topCountry",
  totalVisitors = "totalVisitors",
  videos = "videos",
  watch = "watch",
  youtube = "youtube",
}

/**
 * How a Region Switcher lists the regions: cards, a list, or pills.
 */
export enum CampaignSwitcherVariant {
  cards = "cards",
  list = "list",
  pills = "pills",
}

/**
 * Who wrote a translation: a person or the machine-translation sweep.
 */
export enum CampaignTextSource {
  human = "human",
  machine = "machine",
}

/**
 * The Translations view section a row belongs to: `interface` (Campaign Strings, header and footer text, the campaign title), `landing` (landing page sections), `region` (Region Page sections) or `regions` (each Campaign Region’s name and Region Lines).
 */
export enum CampaignTranslationGroup {
  interface = "interface",
  landing = "landing",
  region = "region",
  regions = "regions",
}

export enum ContactActionType {
  call = "call",
  text = "text",
}

export enum IconColor {
  action = "action",
  disabled = "disabled",
  error = "error",
  inherit = "inherit",
  primary = "primary",
  secondary = "secondary",
}

export enum IconName {
  ArrowBackRounded = "ArrowBackRounded",
  ArrowForwardRounded = "ArrowForwardRounded",
  ArrowLeftContained2 = "ArrowLeftContained2",
  ArrowRightContained2 = "ArrowRightContained2",
  BeenhereRounded = "BeenhereRounded",
  ChatBubbleOutlineRounded = "ChatBubbleOutlineRounded",
  CheckCircleRounded = "CheckCircleRounded",
  ChevronLeftRounded = "ChevronLeftRounded",
  ChevronRightRounded = "ChevronRightRounded",
  ContactSupportRounded = "ContactSupportRounded",
  FormatQuoteRounded = "FormatQuoteRounded",
  Home4 = "Home4",
  Launch = "Launch",
  LinkAngled = "LinkAngled",
  LiveTvRounded = "LiveTvRounded",
  LockOpenRounded = "LockOpenRounded",
  MailOutline = "MailOutline",
  MenuBookRounded = "MenuBookRounded",
  MessageChat1 = "MessageChat1",
  Note2 = "Note2",
  Phone = "Phone",
  PlayArrowRounded = "PlayArrowRounded",
  RadioButtonUncheckedRounded = "RadioButtonUncheckedRounded",
  SendRounded = "SendRounded",
  SubscriptionsRounded = "SubscriptionsRounded",
  TranslateRounded = "TranslateRounded",
  UserProfile2 = "UserProfile2",
  UsersProfiles3 = "UsersProfiles3",
  Volume5 = "Volume5",
}

export enum IconSize {
  inherit = "inherit",
  lg = "lg",
  md = "md",
  sm = "sm",
  xl = "xl",
}

export enum IdType {
  databaseId = "databaseId",
  slug = "slug",
}

export enum JourneyMenuButtonIcon {
  chevronDown = "chevronDown",
  ellipsis = "ellipsis",
  equals = "equals",
  grid1 = "grid1",
  home3 = "home3",
  home4 = "home4",
  menu1 = "menu1",
  more = "more",
}

export enum JourneyStatus {
  archived = "archived",
  deleted = "deleted",
  draft = "draft",
  published = "published",
  trashed = "trashed",
}

export enum MessagePlatform {
  checkBroken = "checkBroken",
  checkContained = "checkContained",
  custom = "custom",
  discord = "discord",
  facebook = "facebook",
  globe2 = "globe2",
  globe3 = "globe3",
  helpCircleContained = "helpCircleContained",
  helpSquareContained = "helpSquareContained",
  home3 = "home3",
  home4 = "home4",
  instagram = "instagram",
  kakaoTalk = "kakaoTalk",
  line = "line",
  linkExternal = "linkExternal",
  mail1 = "mail1",
  menu1 = "menu1",
  messageChat2 = "messageChat2",
  messageCircle = "messageCircle",
  messageNotifyCircle = "messageNotifyCircle",
  messageNotifySquare = "messageNotifySquare",
  messageSquare = "messageSquare",
  messageText1 = "messageText1",
  messageText2 = "messageText2",
  send1 = "send1",
  send2 = "send2",
  settings = "settings",
  shieldCheck = "shieldCheck",
  signal = "signal",
  skype = "skype",
  snapchat = "snapchat",
  telegram = "telegram",
  tikTok = "tikTok",
  viber = "viber",
  vk = "vk",
  weChat = "weChat",
  whatsApp = "whatsApp",
}

export enum Role {
  publisher = "publisher",
}

export enum Service {
  apiJourneys = "apiJourneys",
  apiLanguages = "apiLanguages",
  apiMedia = "apiMedia",
  apiTags = "apiTags",
  apiUsers = "apiUsers",
  apiVideos = "apiVideos",
  youtube = "youtube",
}

export enum TextResponseType {
  email = "email",
  freeForm = "freeForm",
  name = "name",
  phone = "phone",
}

export enum ThemeMode {
  dark = "dark",
  light = "light",
}

export enum ThemeName {
  base = "base",
}

export enum TypographyAlign {
  center = "center",
  left = "left",
  right = "right",
}

export enum TypographyColor {
  error = "error",
  primary = "primary",
  secondary = "secondary",
}

export enum TypographyVariant {
  body1 = "body1",
  body2 = "body2",
  caption = "caption",
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  h4 = "h4",
  h5 = "h5",
  h6 = "h6",
  overline = "overline",
  subtitle1 = "subtitle1",
  subtitle2 = "subtitle2",
}

export enum UserJourneyRole {
  editor = "editor",
  inviteRequested = "inviteRequested",
  owner = "owner",
}

export enum UserTeamRole {
  manager = "manager",
  member = "member",
}

export enum VideoBlockObjectFit {
  fill = "fill",
  fit = "fit",
  zoomed = "zoomed",
}

export enum VideoBlockSource {
  cloudflare = "cloudflare",
  internal = "internal",
  mux = "mux",
  youTube = "youTube",
}

export enum VideoLabel {
  behindTheScenes = "behindTheScenes",
  collection = "collection",
  episode = "episode",
  featureFilm = "featureFilm",
  segment = "segment",
  series = "series",
  shortFilm = "shortFilm",
  trailer = "trailer",
}

export interface ButtonClickEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  label?: string | null;
  value?: string | null;
  action?: ButtonAction | null;
  actionValue?: string | null;
}

export interface ChatOpenEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  value?: MessagePlatform | null;
}

export interface DateTimeFilter {
  gte?: any | null;
  lte?: any | null;
}

export interface JourneyCustomizationDescriptionTranslateInput {
  journeyId: string;
  sourceLanguageName: string;
  targetLanguageName: string;
}

export interface JourneyProfileUpdateInput {
  lastActiveTeamId?: string | null;
  journeyFlowBackButtonClicked?: boolean | null;
  plausibleJourneyFlowViewed?: boolean | null;
  plausibleDashboardViewed?: boolean | null;
}

export interface JourneysFilter {
  featured?: boolean | null;
  template?: boolean | null;
  ids?: string[] | null;
  tagIds?: string[] | null;
  languageIds?: string[] | null;
  limit?: number | null;
  orderByRecent?: boolean | null;
  fromTemplateId?: string | null;
  teamId?: string | null;
}

export interface JourneysQueryOptions {
  hostname?: string | null;
  embedded?: boolean | null;
  journeyCollection?: boolean | null;
  skipRoutingFilter?: boolean | null;
  status?: JourneyStatus[] | null;
}

export interface LanguagesFilter {
  ids?: string[] | null;
  bcp47?: string[] | null;
  iso3?: string[] | null;
  updatedAt?: DateTimeFilter | null;
}

export interface MultiselectSubmissionEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  label?: string | null;
  values: string[];
}

export interface RadioQuestionSubmissionEventCreateInput {
  id?: string | null;
  blockId: string;
  radioOptionBlockId: string;
  stepId?: string | null;
  label?: string | null;
  value?: string | null;
}

export interface SignUpSubmissionEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  name: string;
  email: string;
}

export interface StepNextEventCreateInput {
  id?: string | null;
  blockId: string;
  nextStepId: string;
  label?: string | null;
  value?: string | null;
}

export interface StepPreviousEventCreateInput {
  id?: string | null;
  blockId: string;
  previousStepId: string;
  label?: string | null;
  value?: string | null;
}

export interface StepViewEventCreateInput {
  id?: string | null;
  blockId: string;
  value?: string | null;
}

export interface TextResponseSubmissionEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  label?: string | null;
  value: string;
}

export interface VideoCollapseEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

export interface VideoCompleteEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

export interface VideoExpandEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

export interface VideoPauseEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

export interface VideoPlayEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

export interface VideoProgressEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
  progress: number;
}

export interface VideoStartEventCreateInput {
  id?: string | null;
  blockId: string;
  stepId?: string | null;
  position?: number | null;
  label?: string | null;
  value?: VideoBlockSource | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
